interface LocationFields {
    hideTeacherDetails: boolean,
    city?: string,
    stateFullName: string,
    // Two-letter state code
    state: string,
}

export default ({ hideTeacherDetails, city, stateFullName, state }: LocationFields): string => {
    return (hideTeacherDetails || !city) ? stateFullName : `${city}, ${state}`;
};
